const OrderTypes = {
  FETCH_ORDERS_START: 'FETCH_ORDERS_START',
  FETCH_ORDERS_FAILURE: 'FETCH_ORDERS_FAILURE',
  FETCH_ORDERS_SUCCESS: 'FETCH_ORDERS_SUCCESS',
  FETCH_SINGLE_ORDER_START: 'FETCH_SINGLE_ORDER_START',
  FETCH_SINGLE_ORDER_FAILURE: 'FETCH_SINGLE_ORDER_FAILURE',
  FETCH_SINGLE_ORDER_SUCCESS: 'FETCH_SINGLE_ORDER_SUCCESS',
};

export default OrderTypes;
